module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAgUlEQVQoU5WQwQ2DMAxFn9tFuJINONWjwCSlkySbkJ4QDMCZRUqQIAgQUkR9sWw/f9lfiGFaLXnwBrKlJTh+fIfCu7UETKt1hLa9PU98hsLXEpXslTh0JirJe20koElQcGI6DUkoDv8Ae7UEypRqEPz9Z27bczL8yetwxsjq4WL4DP04L1bda3e1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/status.png
// module id = Z1Gi
// module chunks = 2